import { supabase } from "@/integrations/supabase/client";

export async function trackSocialShare(platform: string, pageSource: string = "/thank-you") {
  try {
    const { error } = await supabase.from("sharing_analytics").insert({
      platform,
      page_source: pageSource,
      user_agent: navigator.userAgent,
    });

    if (error) {
      console.error("Error tracking social share:", error);
    }
  } catch (error) {
    console.error("Failed to track social share:", error);
  }
}

export async function trackReferral() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get("utm_source");
    const utmMedium = urlParams.get("utm_medium");
    const utmCampaign = urlParams.get("utm_campaign");
    const referrer = document.referrer;

    // Only track if we have UTM parameters or a referrer
    if (utmSource || utmMedium || utmCampaign || referrer) {
      const { error } = await supabase.from("referral_tracking").insert({
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        referrer: referrer || null,
        landing_page: window.location.pathname,
      });

      if (error) {
        console.error("Error tracking referral:", error);
      }
    }
  } catch (error) {
    console.error("Failed to track referral:", error);
  }
}

export function buildShareUrl(baseUrl: string, platform: string): string {
  const url = new URL(baseUrl);
  url.searchParams.set("utm_source", platform.toLowerCase());
  url.searchParams.set("utm_medium", "social");
  url.searchParams.set("utm_campaign", "testimonial_share");
  return url.toString();
}

// Google Analytics 4 Event Tracking
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export function trackPageView(path: string, title?: string) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title || document.title,
    });
  }
}

export function trackProductView(productId: string, productName: string, price: number) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'view_item', {
      currency: 'GBP',
      value: price,
      items: [{
        item_id: productId,
        item_name: productName,
        price: price,
        quantity: 1,
      }]
    });
  }
}

export function trackAddToCart(productId: string, productName: string, price: number, quantity: number = 1) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'add_to_cart', {
      currency: 'GBP',
      value: price * quantity,
      items: [{
        item_id: productId,
        item_name: productName,
        price: price,
        quantity: quantity,
      }]
    });
  }
}

export function trackPurchase(
  transactionId: string,
  value: number,
  items: Array<{
    item_id: string;
    item_name: string;
    price: number;
    quantity: number;
  }>
) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      currency: 'GBP',
      value: value,
      items: items,
    });
  }
}

export function trackBeginCheckout(value: number, items: Array<{
  item_id: string;
  item_name: string;
  price: number;
  quantity: number;
}>) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'begin_checkout', {
      currency: 'GBP',
      value: value,
      items: items,
    });
  }
}
